var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2970_111502)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.01958 0H12.9804C13.4149 0 13.7647 0.340854 13.7647 0.764239V2.07695H18.1512C19.1754 2.07695 20 2.88 20 3.878V14.0318C20 14.0479 19.9998 14.0638 19.9994 14.0797C19.9998 14.1087 20 14.1376 20 14.1667C20 17.3883 17.3883 20 14.1667 20C11.5241 20 9.29202 18.2429 8.5749 15.8333H1.84881C0.824603 15.8333 0 15.0298 0 14.0318V3.878C0 2.88 0.824603 2.07695 1.84881 2.07695H6.23528V0.764239C6.23528 0.340854 6.58507 0 7.01958 0ZM9.16667 14.1667L9.16667 14.1655C9.16675 13.7731 9.21205 13.3912 9.29764 13.0248C9.81416 10.8136 11.7981 9.16667 14.1667 9.16667C14.1877 9.16667 14.2087 9.1668 14.2297 9.16706C14.6327 9.17204 15.0242 9.22469 15.3988 9.31964C17.5644 9.86846 19.1667 11.8305 19.1667 14.1667C19.1667 14.688 19.0869 15.1907 18.9388 15.6633C18.3027 17.6936 16.4067 19.1667 14.1667 19.1667C11.9896 19.1667 10.1376 17.7753 9.45118 15.8333C9.26692 15.312 9.16667 14.7511 9.16667 14.1667ZM15.388 8.46139C15.2706 7.24398 14.7215 6.09825 13.8267 5.22638C12.8118 4.23744 11.4353 3.68186 10 3.68186C8.56471 3.68186 7.18821 4.23744 6.1733 5.22638C5.1584 6.21531 4.58824 7.55658 4.58824 8.95514C4.58824 10.3537 5.1584 11.695 6.1733 12.6839C6.78508 13.28 7.52825 13.7187 8.33649 13.9731C8.34948 13.5745 8.40248 13.1859 8.4916 12.8114C7.93906 12.6061 7.43138 12.2885 7.00519 11.8732C6.21092 11.0993 5.76469 10.0496 5.76469 8.95505C5.76469 7.86053 6.21092 6.81083 7.00519 6.03689C7.79946 5.26294 8.87672 4.82814 9.99999 4.82814C11.1233 4.82814 12.2005 5.26294 12.9948 6.03689C13.6371 6.66276 14.0518 7.46896 14.187 8.33337C14.5988 8.33477 15.0005 8.37884 15.388 8.46139Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 11.6667H11.6667V12.5H10.8333V11.6667Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11.6667H17.5V12.5H12.5V11.6667Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 13.3333H11.6667V14.1667H10.8333V13.3333Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.3333H17.5V14.1667H12.5V13.3333Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 15.8333H11.6667V16.6667H10.8333V15.8333Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.8333H17.5V16.6667H12.5V15.8333Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2970_111502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageManage);
export default __webpack_public_path__ + "static/media/ImageManage.e9f2295e9f824addcabe727bfb03437f.svg";
export { ForwardRef as ReactComponent };